"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingTransactionChargingTelemetryValidation = void 0;
class ChargingTransactionChargingTelemetryValidation {
    static isValid(entity) {
        // Validate entity.powerKW for existence and correct type.
        if (entity.powerKW == undefined)
            return false;
        if (typeof entity.powerKW !== "number")
            return false;
        // Validate entity.powerLimitKW for existence and correct type.
        if (entity.powerLimitKW == undefined)
            return false;
        if (typeof entity.powerLimitKW !== "number")
            return false;
        // Validate entity.powerRequestKW for existence and correct type.
        if (entity.powerRequestKW == undefined)
            return false;
        if (typeof entity.powerRequestKW !== "number")
            return false;
        // Validate entity.current for existence and correct type.
        if (entity.current == undefined)
            return false;
        if (typeof entity.current !== "number")
            return false;
        // Validate entity.voltage for existence and correct type.
        if (entity.voltage == undefined)
            return false;
        if (typeof entity.voltage !== "number")
            return false;
        // Validate entity.SoC for existence and correct type.
        if (entity.SoC == undefined)
            return false;
        if (typeof entity.SoC !== "number")
            return false;
        // Validate entity.totalEnergyDelivered for existence and correct type.
        if (entity.totalEnergyDelivered == undefined)
            return false;
        if (typeof entity.totalEnergyDelivered !== "number")
            return false;
        // If entity.detailTime exists, validate that it has the correct type.
        if (entity.detailTime != undefined) {
            if (!(entity.detailTime instanceof Date))
                return false;
        }
        return true;
    }
}
exports.ChargingTransactionChargingTelemetryValidation = ChargingTransactionChargingTelemetryValidation;
